import { render, staticRenderFns } from "./AvailableCourses.vue?vue&type=template&id=45e84b25&scoped=true&"
import script from "./AvailableCourses.vue?vue&type=script&lang=js&"
export * from "./AvailableCourses.vue?vue&type=script&lang=js&"
import style0 from "./AvailableCourses.vue?vue&type=style&index=0&id=45e84b25&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e84b25",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VCol,VRow,VSelect,VSpacer,VTextField})
